import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Popup } from "@progress/kendo-react-popup";
import {
  extendDataItem,
  filterBy,
  mapTree,
  orderBy,
  TreeList,
} from "@progress/kendo-react-treelist";
import React, { useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { NavLink, useHistory } from "react-router-dom";
import Select from "react-select";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/Organization.scss";
import AddToCart from "./AddToCart";
import { Checkbox } from "@progress/kendo-react-inputs";

const subItemsField = "children";
const expandField = "expanded";
const selectField = "selected";

export default function TaskModule(props) {
  const token =
    secureLocalStorage.getItem("loggedClient") === "user"
      ? secureLocalStorage.getItem("userKey")
      : secureLocalStorage.getItem("tenantKey");

  const [openUnit, setOpenUnit] = React.useState(false);
  const [isSortByCount, setIsSortByCount] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [unitTypeList, setUnitTypeList] = React.useState([]);
  const [effortUnitList, setEffortUnitList] = React.useState([]);

  const [dataState, setDataState] = React.useState({
    sort: [{ field: "name", dir: "asc" }],
    filter: [],
  });
  const [expanded, setExpand] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [currentRow, setCurrentRow] = React.useState({});
  const [editOrgFlag, setEditOrgFlag] = React.useState(false);
  const [openDeleteModelFlag, setOpenDeleteModelFlag] = React.useState(false);
  const [searchData, setSearchData] = React.useState([]);
  const [customFieldList, setCustomFieldList] = React.useState([]);
  const [impactList, setImpactList] = React.useState([]);
  const [impactListTemp, setImpactListTemp] = React.useState([]);
  const [impactTemplateList, setImpactTemplateList] = React.useState([]);
  const [selectedCF, setSelectedCF] = React.useState([]);
  const [isPrime, setSetPrime] = React.useState("0");
  const history = useHistory();
  const [editImpactWarningList,setEditImpactWarningList]= React.useState([]);
  const [editCFWarningList,setEditCFWarningList]= React.useState([]);
  const [openCFWarningModelFlag, setOpenCFWarningModelFlag] = React.useState(false);
  const [openImpactWarningModelFlag, setOpenImpactWarningModelFlag] = React.useState(false);

  const [state, setState] = React.useState({
    Name: "",
    UnitName: "",
    UnitTypeId: {},
    Label: "NA",
    Level: 0,
    Description: "",
    Createdby: 0,
    selected: [],
    effortUnitId:{}
  });

  useEffect(() => {
    isAuthorizeUse();
  }, []);
 
  const isAuthorizeUse = async () => {
    try {
      if (!secureLocalStorage.getItem("authToken")) {
        if (props.match.params.id) {
          history.push({
            pathname: `/tenant/${props.match.params.id}`,
          });
        } else {
          history.push({
            pathname: "/",
          });
        }
      } else {
        // getImpactList();
        getUnitTypes();
        getOrganizationsUnits();
        getCustomField();
        getEffortUnitList();
       
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status === 200) {
        setCustomFieldList(response.customFields);
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };
  const handleTaskCount =(e)=>{
    setIsSortByCount(e.value);
    if(e.value===true){
      const filteredData = filterTreeStructureByTaskCount(searchData);
      setData(filteredData);
    }else{
      setData(searchData);
    }
    updateUserWorkstreamSettings(e.value);
  }
  
  const updateUserWorkstreamSettings = async (flag) => {
    try {
      var request = {
        userId: parseInt(secureLocalStorage.getItem("loginUserId")),
        hideEmptyWorkstreams: flag,
        screenFrom: "Task",
      };
      await Api.updateUserWorkstreamSettings(request);
    } catch (error) {}
  };

  const addUnitOpen = (flag) => {
    if (flag === "edit") {
      setOpenUnit(true);
    } else {
      // setState({});
      setEditOrgFlag(false);
      setOpenUnit(true);
      setSelectedCF([]);
      setState({
        ...state,
        effortUnitId: effortUnitList[1]||{},
      })
    }
  };

  const addUnitClose = () => {
    setOpenUnit(false);
    setState({
      Name: "",
      UnitName: "",
      UnitTypeId: {},
      Label: "NA",
      Level: 0,
      Description: "",
      Createdby: 0,
      selected: [],
      effortUnitId:{}
    })
  };
  const onExpandChange = (e) => {
    setExpand(
      e.value
        ? expanded.filter((unitId) => unitId !== e.dataItem.unitId)
        : [...expanded, e.dataItem.unitId]
    );
  };
  const handleDataStateChange = (event) => {
    setDataState(event.data);
  };
  const addExpandField = (dataTree) => {
    return mapTree(dataTree, subItemsField, (item) =>
      extendDataItem(item, subItemsField, {
        [expandField]: expanded.includes(item.unitId),
      })
    );
  };

  const getUnitTypes = async () => {
    let response = await Api.getOrgType();
    if (response.status === 200 && response.unitTypes) {
      var typeList = [];
      for (var i = 0; i < response.unitTypes.length; i++) {
        typeList.push({
          value: response.unitTypes[i].id,
          label: response.unitTypes[i].name,
        });
      }
      setUnitTypeList(typeList);
    }
  };

  const getEffortUnitList = async () => {
    let response = await Api.getEffortUnitsForTasks();
    if (response.status === 200 && response.effortUnits) {
      var typeList = [];
      for (var i = 0; i < response.effortUnits.length; i++) {
        typeList.push({
          value: response.effortUnits[i].effortUnitId,
          label: response.effortUnits[i].effortUnitName,
        });
      }
      setEffortUnitList(typeList);
      
    }
  };

  const getImpactList = async () => {
    let response = await Api.GetAllImpactAndThreshold();
    if (response.status === 200 && response.impact) {
      impactList.map((item) => {
        item["selectedThreshold"] = {};
        item["selected"] = false;
        return item;
      });
      setImpactList(response.impact);
      setImpactListTemp(response.impact);
    }
  };

  const getOrganizationsUnits = async () => {
    try {
      setLoader(true);
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        IsTasksModule: true,
      };
      let response = await Api.getOrgUnits(request);
      if (response.status === 200 && response.organisationUnit) {
        const filteredData = filterTreeStructure(response.organisationUnit);
        // setData(filteredData);
        setSearchData(filteredData);
        setIsSortByCount(response.isHideEmptyWorkstreams);
        if (response.isHideEmptyWorkstreams === true) {
          let filteredData1 = filterTreeStructureByTaskCount(filteredData);
          setData(filteredData1);
        } else {
          setData(filteredData);
        }
        setLoader(false);
      } else {
        setData([]);
        setSearchData([]);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      setData([]);
      console.error(error);
    }
  };

  const filterTreeStructure = (nodes) => {
    // Recursively process the nodes
    return nodes.reduce((result, node) => {
      if (node.isTaskAdmin && node.taskRole) {
        // Include the node and recursively process its children
        result.push({
          ...node,
          children: node.children ? filterTreeStructure(node.children) : [],
        });
      } else if (node.children) {
        // Include only the children if the node is inactive
        result.push(...filterTreeStructure(node.children));
      }
      return result;
    }, []);
  };

  const filterTreeStructureByTaskCount = (nodes) => {
    if (!nodes || nodes.length === 0) {
      return [];
    }
    
    // Recursively process the nodes
    return nodes.reduce((result, node) => {
      // Process children first to determine if they have any tasks
      const filteredChildren = node.children ? filterTreeStructureByTaskCount(node.children) : [];
      
      if (node.tasksCount && node.tasksCount > 0) {
        // If node has tasks, include it with its filtered children
        result.push({
          ...node,
          children: filteredChildren
        });
      } else if (filteredChildren.length > 0) {
        // If node doesn't have tasks but has children with tasks,
        // flatten those children into the result
        result.push(...filteredChildren);
      }
      // If node has no tasks and no children with tasks, it's excluded
      
      return result;
    }, []);
  };

  const validateData = () => {
    var flag = true;
    if (!state.UnitName) {
      flag = false;
      toastr.error("The name field should not be empty.");
    } else if (!state.UnitTypeId || !state.UnitTypeId.value) {
      flag = false;
      toastr.error("The Type field should not be empty.");
    }

    return flag;
  };

  const getImpactRequest = () => {
    let arr = [];
    impactList.map((item) => {
      if (item.selected && item.impactType == "Quantitative") {
        arr.push({
          impactId: item.impactId,
          thresholdId: item.selectedThreshold
            ? item.selectedThreshold.thresholdId
            : 0,
        });
      }
      return item;
    });
    return arr;
  };
  const getQualitativeImpacts = () => {
    let arr = [];
    impactList.map((item) => {
      if (item.selected && item.impactType == "Qualitative") {
        arr.push(item.impactId);
      }
      return item;
    });
    return arr;
  };
  const getCFRequest = () => {
    let arr = [];
    selectedCF.map((item) => {
      arr.push(item.id);
      return item;
    });
    return arr;
  };
  const saveOrganization = async () => {
    var flag = await validateData();
    if (!flag) {
      return;
    }
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var createdby =
      loggedClient === "user"
        ? secureLocalStorage.getItem("userId")
        : secureLocalStorage.getItem("tenantId");
    var requestParams = {};
    let impacts = getImpactRequest();
    let qualitativeImpacts = getQualitativeImpacts();
    let cfValue = getCFRequest();
    if (currentRow && currentRow.unitId) {
      requestParams = {
        Name: state.UnitName.trim(),
        UnitName: state.UnitName.trim(),
        UnitTypeId: state.UnitTypeId.value,
        effortUnitId:state.effortUnitId.value,
        Label: "NA", //state.Label,
        Level: 1,
        Description: state.Description,
        Createdby: parseInt(createdby),
        parentUnit: currentRow.unitId,
        impacts: impacts,
        qualitativeImpacts: qualitativeImpacts,
        CustomFields: cfValue,
        CreatedDate: new Date(),
        primeId:state.primeId,
        isPrime:isPrime=="0"?false:true,
        IsTasksModule:true
      };
    } else {
      requestParams = {
        Name: state.UnitName.trim(),
        UnitName: state.UnitName,
        UnitTypeId: state.UnitTypeId.value,
        effortUnitId:state.effortUnitId.value,
        Label: "NA", //state.Label,
        Level: 1,
        Description: state.Description,
        Createdby: parseInt(createdby),
        CreatedDate: new Date(),
        impacts: impacts,
        CustomFields: cfValue,
        qualitativeImpacts: qualitativeImpacts,
        primeId:state.primeId,
        isPrime:isPrime=="0"?false:true,
        IsTasksModule:true
      };
    }
    setLoader(true);
    let response = await Api.addOrgUnit(requestParams);
    if (response.status === 200) {
      addUnitClose();
      setState({});
      setCurrentRow({});
      setLoader(false);
      getOrganizationsUnits();
      toastr.success(response.message);
    } else {
      toastr.error(response.message);
      setLoader(false);
    }
  };

  const checkCFWarning = () => {
    let flag = false;
    editCFWarningList.map((item) => {
      let res = selectedCF.find((cf) => cf.id == item.customFieldId);
      if (!res) {
        flag = true;
      }
    });
    return flag;
  };
  const checkImpactWarning=()=>{
    let flag = false;
    editImpactWarningList.map((item) => {
      let res = impactList.find((imp) =>item.selected && imp.impactId == item.impactId);
      if (!res) {
        flag = true;
      }
    });
    return flag;
  }

  
   
  const updateOrganization = async (warnFlag) => {
    var flag = await validateData();
    if (!flag) {
      return;
    }

    var warningFlagCF = await checkCFWarning();
    if (warningFlagCF && warnFlag == "UPDATE") {
      setOpenUnit(false);
      openCFWarningPopup();
      return;
    }
    var warningFlagImpact = await checkImpactWarning();
    if (warningFlagImpact && warnFlag == "UPDATE") {
      setOpenUnit(false);
      openImpactWarningPopup();
      return;
    }
    setLoader(true);
    let impacts = getImpactRequest();
    let qualitativeImpacts = getQualitativeImpacts();
    let cfValue = getCFRequest();
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    var createdby =
      loggedClient === "user"
        ? secureLocalStorage.getItem("userId")
        : secureLocalStorage.getItem("tenantId");

    var requestParams = {
      Name: state.UnitName.trim(),
      UnitName: state.UnitName.trim(),
      UnitTypeId: state.UnitTypeId.value,
      Label: state.Label,
      Level: parseInt(state.Level),
      Description: state.Description,
      UpdatedBy: parseInt(createdby),
      UpdatedDate: new Date(),
      UnitId: state.UnitId,
      parentUnit: state.ParentUnit,
      impacts: impacts,
      QualitativeImpacts: qualitativeImpacts,
      CustomFields: cfValue,
      isPrime:isPrime=="0"?false:true,
      primeId:state.primeId,
      IsTasksModule:true,
      effortUnitId:state.effortUnitId.value,
    };
   
    let response = await Api.editOrgUnit(requestParams);
    if (response.status === 200) {
      toastr.success(response.message);
      // resetPersistence(state.UnitId);
      addUnitClose();
      setState({});
      setCurrentRow({});
      await getOrganizationsUnits();
      setLoader(false);
     
      closeCFWarningPopup();
      closeImpactWarningPopup();
    } else {
      setLoader(false);
      toastr.error(response.message);
    }
  };

  const resetPersistence = async (organizationUnitId) => {
    try {
      let req = {
        RiskDetails: undefined,
        WorkstreamId: organizationUnitId,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        resetPersistenceForAllUser:true
      };
      await Api.persistRisks(req);
      // code change 
      req = {
        ActionDetails: undefined,
        WorkstreamId: organizationUnitId,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        resetPersistenceForAllUser:true
      };
      await Api.persistAction(req);

      req = {
        RiskDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        resetPersistenceForAllUser:true
      };
      await Api.persistHomeRisks(req);

      req = {
        ActionDetails: undefined,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
        resetPersistenceForAllUser:true
      };
      await Api.persistHomeAction(req);
    } catch (err) {
      console.log(err);
    }
  };
  const processData = () => {
    let filteredData = filterBy(data, dataState.filter, subItemsField);
    let sortedData = orderBy(filteredData, dataState.sort, subItemsField);
    return addExpandField(sortedData);
  };

  const deleteProjectOpen = (e) => {
    setOpenDeleteModelFlag(true);
    const selected = e.dataItem;
    setCurrentRow(selected);
  };

  const deleteProjectClose = () => {
    setOpenDeleteModelFlag(false);
  };

  
  const openCFWarningPopup = () => {
    setOpenCFWarningModelFlag(true)
  };

  const closeCFWarningPopup = () => {
    setOpenCFWarningModelFlag(false);
  };

  const openImpactWarningPopup = () => {
    setOpenImpactWarningModelFlag(true)
  };

  const closeImpactWarningPopup = () => {
    setOpenImpactWarningModelFlag(false);
  };

  const [showAddToCart, setShowAddToCart] = React.useState(false);

  const openAddToCart = (e) => {
    setShowAddToCart(true);
    const selected = e.dataItem;
    setCurrentRow(selected);
  };
  const closeAddToCart = () => {
    setShowAddToCart(false);
  };

  const handleRowClickCreateNewChild = (e) => {
    const selected = e.dataItem;
    setCurrentRow(selected);
    addUnitOpen("edit");
    setEditOrgFlag(false);
    setState({
      ...state,
      effortUnitId: effortUnitList[1]||{},
    })
  };

  const removeOrgUnit = async (row) => {
    const requestParams = {
      DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      UnitId: currentRow.unitId,
      DeletedDate: new Date(),
    };
    setLoader(true);
    let response = await Api.deleteOrgUnit(requestParams);
    if (response.status === 200) {
      getOrganizationsUnits();
      setLoader(false);
      setOpenDeleteModelFlag(false);
      setCurrentRow({});
      toastr.success(response.message);
    } else {
      setLoader(false);
      setOpenDeleteModelFlag(false);
      toastr.error(response.message);
    }
  };
  const editOrganizationUnit = async (row) => {
    let selectedRow = row.dataItem;
    setCurrentRow(selectedRow);
    if (row && row.dataItem) {
      await getImpactList();
      let existingImpact = [];
      let data = impactListTemp.map((item) => {
        let temp = row.dataItem.impactThresholds.find(
          (item1) =>
            item1.impactId === item.impactId || item1.id === item.impactId
        );
        if (temp && temp.impactType === "Quantitative") {
          if (!temp.isDefault) {
            let threshold = item.impactThresholds.find(
              (thr) => thr.thresholdId === temp.thresholdId
            );
            item["selectedThreshold"] = threshold;
          } else {
            item["selectedThreshold"] = {
              thresholdId: 0,
              name: "Default",
            };
          }
          item["selected"] = true;
        } else if (temp && temp.impactType === "Qualitative") {
          item["selectedThreshold"] = {
            thresholdId: 0,
            name: "Default",
          };
          item["selected"] = true;
        }
        if (temp) {
          existingImpact.push(item);
        }
        return item;
      });
      let arr = [];
      row.dataItem.customFields.map((item) => {
        let cf = customFieldList.find(
          (item2) => item2.id === item.customFieldId
        );
        if (cf) {
          arr.push(cf);
        }
        return item;
      });
      let res = [];
      if (row.dataItem.isPrime == true&&secureLocalStorage.getItem("isPrime") == true) {
        res = data.filter((item) =>
          row.dataItem.impactThresholds.find(
            (item2) => item2.impactId === item.impactId
          )
        );
      } else {
        res = data;
      }

      setSelectedCF(arr);
      setImpactList(res);
      //Check deselected or not,in CF and impact
      setEditImpactWarningList(existingImpact);
      setEditCFWarningList(row.dataItem.customFields);
      let primeObj = impactTemplateList.find(
        (item) => item.id == row.dataItem.primeId
      );
      let effortObj=effortUnitList.find(
        (item) => item.value == row.dataItem.effortUnitId
      );
      setState({
        Name: row.dataItem.name,
        UnitName: row.dataItem.unitName,
        UnitTypeId: {
          value: row.dataItem.unitTypeId,
          label: row.dataItem.unitTypeName,
        },
        Label: row.dataItem.label,
        Level: row.dataItem.level,
        Description: row.dataItem.description,
        UnitId: row.dataItem.unitId,
        ParentUnit: row.dataItem.parentUnit,
        primeId: row.dataItem.primeId,
        primeObj: primeObj,
        effortUnitId:effortObj
      });
      if (secureLocalStorage.getItem("isPrime") == true) {
        let primeVal = row.dataItem.isPrime == true ? "1" : "0";
        setSetPrime(primeVal);
      } else {
        setSetPrime("0");
      }
    }
    setEditOrgFlag(true);
    addUnitOpen("edit");
  };



  const itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const handlerow = (e) => {
    console.log(" e.dataItem.unitId", e.dataItem.unitId);
    let path = `/${secureLocalStorage.getItem(
      "loggedClient"
    )}/${token}/home/taskregister/
  ${e.dataItem.unitId}`;
    history.push(path);
  };

  const handleChangeCustomFields = (e) => {
    setSelectedCF(e.value);
  };

  return (
    <div className="orgContainer">
      {loader ? (
        <span className="MatTableSpinner">
          <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
        </span>
      ) : null}
      <div className="orgHeader d-flex">
        <h4>
          {/* Organization Unit */}
          Workstream
        </h4>

        {secureLocalStorage.getItem("role") === "View Only" ||
        secureLocalStorage.getItem("role") === "Project Admin" ||
        secureLocalStorage.getItem("role") === "Standard User" ||
        secureLocalStorage.getItem("role") === "Super User" ||
        secureLocalStorage.getItem("role") === "-" ? (
          <div className="ml-auto d-flex flex-xs-row flex-sm-row flex-md-row flex-lg-row flex-xl-row">
            <div className="searchContainer">
            <Checkbox
                // defaultValue={isSortByCount}
                checked={isSortByCount}
                label={"Hide Empty Workstreams"}
                onChange={handleTaskCount}
              />
            </div>
          </div>
        ) : (
          <div className="ml-auto d-flex flex-xs-row flex-sm-row flex-md-row flex-lg-row flex-xl-row">
            <div className="searchContainer">
              <Checkbox
                // defaultValue={isSortByCount}
                checked={isSortByCount}
                label={"Hide Empty Workstreams"}
                onChange={handleTaskCount}
              />
            </div>

            <a href="#" onClick={addUnitOpen}>
              Add Workstream
            </a>
          </div>
        )}
      </div>

      <div className="Div orgtable">
        <Popup show={openDeleteModelFlag} popupClass={"popup-content"}>
          <div className="deleteModelCont">
            {loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <h3>Are you sure you want to delete this workstream?</h3>
            <div className="btnCont">
              <button onClick={() => removeOrgUnit()} className="deleteBtn">
                Delete
              </button>
              <button onClick={deleteProjectClose} className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup show={openCFWarningModelFlag} popupClass={"popup-content"}>
          <div className="warningModelCont">
            {loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <h3>
              Are you sure to remove custom field(s) from the workstream? Any
              dataset created with filters on these custom fields will become
              invalid.
            </h3>
            <div className="warnbtnGroup">
              <button
                className="btnPrimary"
                onClick={() => updateOrganization("CF")}
              >
                Proceed
              </button>

              <button onClick={closeCFWarningPopup} className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup show={openImpactWarningModelFlag} popupClass={"popup-content"}>
          <div className="warningModelCont">
            {loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <h3>
              Are you sure to remove custom impact(s) from the workstream? Any
              dataset created with filters on these custom fields will become
              invalid.
            </h3>
            <div className="warnbtnGroup">
              <button
                className="btnPrimary"
                onClick={() => updateOrganization("IMPACT")}
              >
                Proceed
              </button>

              <button onClick={closeImpactWarningPopup} className="cancelBtn">
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <TreeList
          style={{ maxHeight: "510px", overflow: "auto", cursor: "pointer" }}
          expandField={expandField}
          subItemsField={subItemsField}
          onExpandChange={onExpandChange}
          // sortable={{ mode: "multiple" }}
          // resizable
          {...dataState}
          data={processData()}
          onDataStateChange={handleDataStateChange}
          selectedField={selectField}
          onRowClick={handlerow}
          // filterable={true}
          columns={[
            {
              field: "unitName",
              title: "Name",
              width: 250,
              expandable: true,
            },
            {
              field: "tasksCount",
              title: "Total Tasks",
              width: 50,
              cell: (row) => {
                return (
                  <td title={row.dataItem.tasksCount}>
                    {row.dataItem.tasksCount === 0
                      ? ""
                      : row.dataItem.tasksCount}
                  </td>
                );
              },
            },
            {
              field: "unitTypeName",
              title: "Type",
              width: 100,
            },
            {
              field: "description",
              title: "Description",
              width: 100,
              cell: (row) => {
                return (
                  <td title={row.dataItem.description}>
                    {/* {row.dataItem.isVisible && ( */}
                    {/* <span title={row.dataItem.description}> */}
                    {row.dataItem.description}
                    {/* </span> */}
                    {/* )} */}
                  </td>
                );
              },
            },

            {
              field: "selectedCustomFields",
              title: "Custom Fields",
              width: 60,
              cell: (row) => {
                return (
                  <td title={row.dataItem.selectedCustomFields}>
                    {row.dataItem.selectedCustomFields.toString()}
                  </td>
                );
              },
            },

            {
              title: "Actions",
              width: 50,
              cell: (row) => {
                return (
                  <td title={row.dataItem.taskRole}>
                    {row.dataItem.taskRole === "Standard User" ||
                    row.dataItem.taskRole === "View Only" ||
                    row.dataItem.taskRole === "Project Admin" ||
                    row.dataItem.taskRole === "Super User" ? (
                      <div className="actionBtnContainer">
                        <div className="actionCellContainer">
                          <button>
                            <img
                              title="Add to email cart"
                              src={Images.CART}
                              onClick={() => openAddToCart(row)}
                              width="12"
                              alt=""
                            />
                          </button>
                        </div>
                        <div className="actionCellContainer">
                          <NavLink
                            title="Go to Task"
                            class="riskLink"
                            to={`/${secureLocalStorage.getItem(
                              "loggedClient"
                            )}/${token}/home/taskregister/${
                              row.dataItem.unitId
                            }`}
                          >
                            <img
                              src={Images.VIEWDATA}
                              width="12"
                              alt="Go to Task"
                            />
                          </NavLink>
                        </div>
                      </div>
                    ) : !row.dataItem.taskRole ? (
                      ""
                    ) : (
                      <div className="actionBtnContainer">
                        <div className="actionCellContainer">
                          <button className="close">
                            <img
                              title="Remove workstream "
                              src={Images.CLOSE}
                              onClick={() => deleteProjectOpen(row)}
                              width="10"
                              alt=""
                            />
                          </button>
                        </div>
                        <div className="actionCellContainer">
                          <button>
                            <img
                              title="Edit Workstream"
                              src={Images.EDITICON}
                              onClick={() => editOrganizationUnit(row)}
                              width="10"
                              alt=""
                            />
                          </button>
                        </div>
                        <div className="actionCellContainer">
                          <button>
                            <img
                              title="Add child workstream"
                              src={Images.UNIT}
                              onClick={() => handleRowClickCreateNewChild(row)}
                              width="10"
                              alt=""
                            />
                          </button>
                        </div>
                        <div className="actionCellContainer">
                          <button>
                            <img
                              title="Add to email cart"
                              src={Images.CART}
                              onClick={() => openAddToCart(row)}
                              width="12"
                              alt=""
                            />
                          </button>
                        </div>
                        <div className="actionCellContainer">
                          <NavLink
                            title="Go to Task"
                            class="riskLink"
                            to={`/${secureLocalStorage.getItem(
                              "loggedClient"
                            )}/${token}/home/taskregister/${
                              row.dataItem.unitId
                            }`}
                          >
                            <img
                              src={Images.VIEWDATA}
                              width="12"
                              alt="Go to Task"
                            />
                          </NavLink>
                        </div>
                      </div>
                    )}
                  </td>
                );
              },
            },
          ]}
          // onRowDrop={onRowDrop}
          // row={TreeListDraggableRow}
        />
      </div>

      <Dialog open={openUnit} onClose={addUnitClose}>
        <div className="addUnitForm">
          {loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <h3>{editOrgFlag ? "Update Workstream" : "Add Workstream"}</h3>
          <div className="formCont">
            <div className="fieldCol">
              <div className="fieldCont">
                <label>Name *</label>
                <input
                  type="text"
                  value={state.UnitName}
                  autoComplete="off"
                  onChange={(e) =>
                    setState({
                      ...state,
                      UnitName: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="fieldCol rm-dropdown">
              <div className="fieldCont">
                <label>Type *</label>
                <Select
                  value={state.UnitTypeId}
                  onChange={(e) =>
                    setState({
                      ...state,
                      UnitTypeId: e,
                    })
                  }
                  options={unitTypeList}
                  placeholder="--Select Type--"
                />
              </div>
            </div>
            <div className="fieldCol">
              <div className="fieldCont">
                <label>Description</label>
                <textarea
                  autoComplete="off"
                  value={state.Description}
                  onChange={(e) =>
                    setState({
                      ...state,
                      Description: e.target.value,
                    })
                  }
                ></textarea>
              </div>
            </div>
            <div className="fieldCol rm-dropdown">
              <div className="fieldCont">
                <label>Effort Unit</label>
                <Select
                  value={state.effortUnitId}
                  onChange={(e) =>
                    setState({
                      ...state,
                      effortUnitId: e,
                    })
                  }
                  options={effortUnitList}
                  placeholder="--Select Effort--"
                />
              </div>
            </div>
            <div className="fieldCol rm-dropdown">
              <div className="fieldCont">
                <label>Select custom fields</label>
                <MultiSelect
                  // style={{ width: "200px" }}
                  id="id"
                  onChange={(e) => handleChangeCustomFields(e)}
                  // onBlur={this.handleChangeBlur}
                  itemRender={itemRender}
                  value={selectedCF}
                  data={customFieldList}
                  valueField="id"
                  textField="fieldName"
                  autoClose={false}
                  // tags={selectedCF.length > 0 ?
                  //     [ { text: `${selectedCF.length} items selected`} ] : []
                  // }
                />
              </div>
            </div>
          </div>

          <div className="btnGroup">
            {editOrgFlag ? (
              <button
                className="btnPrimary"
                onClick={() => updateOrganization("UPDATE")}
              >
                Update
              </button>
            ) : (
              <button className="btnPrimary" onClick={saveOrganization}>
                Add
              </button>
            )}

            <button className="btnDark" onClick={addUnitClose}>
              Cancel
            </button>
          </div>
        </div>
      </Dialog>

      <Popup show={showAddToCart} popupClass={"popup-content"}>
        <AddToCart
          // {...props}
          closeAddToCart={() => closeAddToCart()}
          cartViewDetailsId={currentRow.unitId}
          cartViewType={"TaskWorkstream"}
        />
      </Popup>
    </div>
  );
}
